export default "__VITE_ASSET__DGJYNEwi__"